import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=23a6152e&"
import script from "./plan.vue?vue&type=script&lang=js&"
export * from "./plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports